import {
    GET_ROUTE_ID_TRACKING_LOADING,
    GET_ROUTE_ID_TRACKING_SUCCESS,
    GET_ROUTE_ID_TRACKING_REJECT
} from "../../actions/home/getByIdOnRoute";

import {
    GET_ALL_ROUTE_TRACKING_LOADING,
    GET_ALL_ROUTE_TRACKING_SUCCESS,
    GET_ALL_ROUTE_TRACKING_REJECT
} from "../../actions/home/getAllOnRoutes"


import {
    GET_ROUTE_LAST_TRACKING_LOADING,
    GET_ROUTE_LAST_TRACKING_SUCCESS,
    GET_ROUTE_LAST_TRACKING_REJECT
} from "../../actions/home/getByLastRoute"

import {
    GET_ROUTE_POINT_ID_TRACKING_LOADING,
    GET_ROUTE_POINT_ID_TRACKING_SUCCESS,
    GET_ROUTE_POINT_ID_TRACKING_REJECT
} from "../../actions/home/GetDeliveryPointsById"

import {
    GET_ALL_ROUTE_BY_TOKEN_LOADING,
    GET_ALL_ROUTE_BY_TOKEN_SUCCESS,
    GET_ALL_ROUTE_BY_TOKEN_REJECT
} from "../../actions/home/getAllOnRoutesByToken"

import {
    GET_ROUTE_POINT_TOKEN_TRACKING_LOADING,
    GET_ROUTE_POINT_TOKEN_TRACKING_SUCCESS,
    GET_ROUTE_POINT_TOKEN_TRACKING_REJECT
} from "../../actions/home/GetDeliveryPointsByToken"

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    last: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    tracking: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    routesByToken: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    trackingByToken: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    }
}

const homeReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_ALL_ROUTE_TRACKING_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_ALL_ROUTE_TRACKING_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_ALL_ROUTE_TRACKING_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }
        // ------------- GET ID Details --------------------
        case GET_ROUTE_ID_TRACKING_LOADING: return {
            ...state,
            detail: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_ID_TRACKING_SUCCESS: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_ID_TRACKING_REJECT: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: null,
                error: action.payload?.response?.data
            }
        }
        // ------------- GET LAST ROUTE --------------------
        case GET_ROUTE_LAST_TRACKING_LOADING: return {
            ...state,
            last: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_LAST_TRACKING_SUCCESS: return {
            ...state,
            last: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_LAST_TRACKING_REJECT: return {
            ...state,
            last: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: null,
                error: action.payload?.response?.data
            }
        }
        // ------------- GET ID Details --------------------
        case GET_ROUTE_POINT_ID_TRACKING_LOADING: return {
            ...state,
            tracking: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_POINT_ID_TRACKING_SUCCESS: return {
            ...state,
            tracking: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_POINT_ID_TRACKING_REJECT: return {
            ...state,
            tracking: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: null,
                error: action.payload?.response?.data
            }
        }
        // ------------- GET DELIVERY POINTS BY TOKEN --------------------
        case GET_ROUTE_POINT_TOKEN_TRACKING_LOADING: return {
            ...state,
            trackingByToken: { isLoading: true, isSuccess: false, isReject: false, data: [], error: {} }
        }
        case GET_ROUTE_POINT_TOKEN_TRACKING_SUCCESS: return {
            ...state,
            trackingByToken: { isLoading: false, isSuccess: true, isReject: false, error: {}, ...action.payload }
        }
        case GET_ROUTE_POINT_TOKEN_TRACKING_REJECT: return {
            ...state,
            trackingByToken: { isLoading: false, isSuccess: false, isReject: true, data: null, error: action.payload?.response?.data }
        }
        // ------------- GET ALL BY TOKEN --------------------
        case GET_ALL_ROUTE_BY_TOKEN_LOADING: return {
            ...state,
            routesByToken: { isLoading: true, isSuccess: false, isReject: false, data: [], error: {} }
        }
        case GET_ALL_ROUTE_BY_TOKEN_SUCCESS: return {
            ...state,
            routesByToken: { isLoading: false, isSuccess: true, isReject: false, error: {}, ...action.payload }
        }
        case GET_ALL_ROUTE_BY_TOKEN_REJECT: return {
            ...state,
            routesByToken: { isLoading: false, isSuccess: false, isReject: true, data: [], error: action.payload?.response?.data }
        }
        default: return state;
    }
}

export default homeReducer